<template>
  <div class="container">
    <div class="scrollable">
      <div class="content">
        <div class="title">{{ content.title }}</div>
        <div class="contact-content-container">
          <div class="contact-form">
            <div class="label">{{ content.form.labelName }}</div>
            <input
              class="input"
              type="text"
              :placeholder="content.form.placeholderName"
              v-model="name"
            />
            <div class="label">{{ content.form.labelEmail }}</div>
            <input
              class="input"
              type="text"
              :placeholder="content.form.placeholderEmail"
              v-model="email"
            />
            <div class="label">{{ content.form.labelPhone }}</div>
            <input
              class="input"
              type="text"
              :placeholder="content.form.placeholderPhone"
              v-model="phone"
            />
            <div class="label">{{ content.form.labelReason }}</div>
            <select class="input" v-model="reason">
              <option value disabled selected>{{ content.form.placeholderReason }}</option>
              <option
                v-for="reason in content.form.optionsReason"
                :key="reason.value"
                :value="reason.value"
              >{{ reason.name }}</option>
            </select>
            <div class="label">{{ content.form.labelMessage }}</div>
            <textarea
              class="input"
              v-model="message"
              cols="30"
              rows="10"
              :placeholder="content.form.placeholderMessage"
            ></textarea>
            <button class="input" @click="submit()">{{ content.form.labelButton }}</button>
          </div>
          <div v-html="content.description"></div>
        </div>
      </div>
    </div>
    <LovalFooter :links="links" />
  </div>
</template>

<script>
import axios from 'axios'
import LovalFooter from '../LovalFooter'
export default {
  components: {
    LovalFooter
  },
  props: ['content', 'links'],
  data () {
    return {
      name: '',
      email: '',
      phone: '',
      reason: '',
      message: ''
    }
  },
  methods: {
    submit () {
      // send email
      let url = '../../php/send_email.php'
      const formData = {
        name: this.name,
        email: this.email,
        phone: this.phone,
        reason: this.reason,
        message: this.message,
        lang: this.$route.params.lang
      }

      let fd = new FormData()
      let keys = Object.keys(formData)
      keys.forEach(key => {
        fd.append(key, formData[key])
      })

      axios
        .post(url, fd)
        .then(result => {
          console.log(result.data)
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>
<style lang="scss" scoped>
@import url("./style.scss");
@import url("./industries-style.scss");
.scrollable {
  height: calc(100% - var(--loval-footer-height));
  overflow: auto;
  padding: 10px;
  box-sizing: border-box;
}
.input {
  width: 100%;
  background-color: inherit;
  border-width: 1px;
  border-style: solid;
  border-color: lightsteelblue;
  font-family: inherit;
  margin: 0;
  padding: 2px;
  box-sizing: border-box;
  margin-bottom: 10px;
}
textarea.input {
  height: 60px;
}
@media only screen and (min-width: 576px) {
  .contact-content-container {
    display: flex;
    position: relative;
  }
  .contact-form {
    margin-right: 10px;
    width: 50%;
  }
}
@media only screen and (min-width: 768px) {
  .scrollable {
    padding: 30px;
  }
  .contact-form {
    margin-right: 30px;
  }
}
@media only screen and (min-width: 1200px) {
  .content {
    padding: 20px 30px;
    background: var(--very-light-blue);
    border-top-left-radius: 30px;
    min-height: calc(100% - 40px);
  }
  .input,
  .label {
    display: inline-block;
    width: 50%;
    vertical-align: top;
  }
  button.input {
    float: right;
  }
}
</style>
